import React from 'react';
import { FaTrash, FaEdit } from 'react-icons/fa';

type Props = {
  setupdateModal: any;
  setdeleteModal: any;
};

const Options: React.FC<Props> = ({ setupdateModal, setdeleteModal }) => {
  return (
    <td className='absolute top-6 right-24 bg-white z-10 text-xs'>
      <li className='list-none p-1 border'>
        <button
          onClick={() => setupdateModal(true)}
          className='flex items-center'
        >
          <FaEdit className='mr-1' />
          Edit
        </button>
      </li>
      <li className='list-none p-1 border-b border-x'>
        <button
          onClick={(e) => setdeleteModal(true)}
          className='flex items-center'
        >
          <FaTrash className='mr-1' /> Delete
        </button>
      </li>
    </td>
  );
};

export default Options;
